import { environment } from 'src/environments/environment';

export enum LanguagesEnum {
    SPANISH = 'es',
    ENGLISH = 'en'
}

export const GLOBAL_CONFIG: IGlobalConfig = {
    config: getConfig(),
    languages: [LanguagesEnum.ENGLISH, LanguagesEnum.SPANISH],
    defaultLanguage: LanguagesEnum.ENGLISH
};

interface IGlobalConfig {
    config: IConfig;
    languages: LanguagesEnum[];
    defaultLanguage: LanguagesEnum;
}

interface IConfig {
    backendOAuth: string;
    backendHost: string;
    clientId: string;
    enableSecurity: string;
    apiScope: string;
    hostName: string;
    unprotectedResources: string[];
    redirectUri: string;
}

function getConfig(): IConfig {
    const config: IConfig = (window as any).appConfig;
    if (environment.proxy) {
        config.backendHost = '/admin';
    }
    return config;
}
